const getLineItemProduct = (lineItem)=>{
    if (lineItem.__typename === 'LineItemBundle') {
        var ref;
        const bundleProduct = (ref = lineItem.bundleLineItems.find((item)=>item.isMainBundleLineItem
        )) === null || ref === void 0 ? void 0 : ref.legacyProduct;
        if (!bundleProduct) {
            return lineItem.bundleLineItems[0].legacyProduct;
        }
        return bundleProduct;
    }
    return lineItem.legacyProduct;
};

export { getLineItemProduct };
//# sourceMappingURL=get-line-item-product.js.map
